import { ServiceMaker, methods, services } from "../services";

export const createTemplateWhatsapp = payload =>
  ServiceMaker(
    `/smsemail/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateWhatsapp = payload =>
  ServiceMaker(
    `/smsemail/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const fetchWhatsappTemplateAll = (payload) =>
  ServiceMaker(
    `/smsemail/templates?service=${payload.service}`,
    methods.GET,
    services.master,
    payload
  );
